var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',{staticClass:"text-badgeError text-xs"},[(!_vm.customError)?_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.getCustomErrorMessage)},on:{"click":_vm.goToRoute}})])])}
var staticRenderFns = []

export { render, staticRenderFns }